import { isCognitoEnabled } from 'common/constants/featureFlag';

export default function isUserLoggedIn({ accessToken, expiresAt }) {
  // Since cognito already handle the token expiration, we don't need to check the expiresAt
  if (isCognitoEnabled) return !!accessToken;

  return accessToken && expiresAt && new Date().getTime() < expiresAt;
}
